import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { IAuftragTableOrder, INewProfileInputDto, IProfileDto } from "../types/Types";

/**
 * @author mb
 */
export const AdminProfileAPI = createApi({
    reducerPath: "adminProfileAPI",
    baseQuery: fetchBaseQuery(
        {
            baseUrl: process.env.REACT_APP_API_URL! + process.env.REACT_APP_API_VERSION! + "adminprofile",
            credentials: 'include'
        }),
    tagTypes: ['adminProfileAPI'], // for caching
    endpoints: (builder) => ({
        getProfiles: builder.mutation<IProfileDto[], void>(
            {
                query: () => ({
                    url: '',
                    method: 'get',
                    params: {
                        
                    },
                    credentials: 'include'
                })
            }
        ),
        getProfile: builder.mutation<IProfileDto, string>(
            {
                query: (uid) => ({
                    url: `` + uid,
                    method: 'get',
                    credentials: 'include',
                })
            }
        ),
        deleteProfile: builder.mutation<void, string>(
            {
                query: (uid) => ({
                    url: `` + uid,
                    method: 'delete',
                    credentials: 'include',
                })
            }
        ),
        createOrUpdateProfileService: builder.mutation<void, INewProfileInputDto>(
            {
                query: (dto) => ({
                    url: `createOrUpdate`,
                    method: 'put',
                    credentials: 'include',
                    body: dto
                })
            }
        ),
       
       
    })
});

export const {
    
    useGetProfilesMutation,
    useGetProfileMutation,
    useDeleteProfileMutation,
    useCreateOrUpdateProfileServiceMutation,
    
} = AdminProfileAPI;
